var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bannerType
    ? _c("Banner", {
        attrs: {
          bannerText: _vm.bannerText,
          bannerType: _vm.bannerType,
          learnMoreLink: "https://status.jumpcloud.com/",
          learnMoreText: "View status page",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }